import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

export const testId = 'moveInTariffInfoTestId';

type MoveInTariffInfoProps = {
  shouldShow?: boolean;
};

export const MoveInTariffInfo = ({ shouldShow }: MoveInTariffInfoProps) => {
  if (!shouldShow) {
    return null;
  }

  return (
    <NsStandout color="cyan" data-testid={testId}>
      <h5>Tariff rates</h5>
      <p>
        Your selected tariff will start from today. Any energy used before today
        will be charged at Standard Variable rates.
      </p>
    </NsStandout>
  );
};
